import React from 'react'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { DashboardLayout } from '../../patientLayouts'
import PatientVitals from '../../components/MyVitals/PatientVitalsLayout'
import { Link, useParams } from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'

const PatientVitalsPage = () => {
  const classes = useStyles()
  return (
    <DashboardLayout>
      <Link to="/patient/selectPatient" className={classes.navLink}>
        <button className={classes.Backbtn}>
          <IoIosArrowBack className={classes.Backicon} />
          Select Patient Account
        </button>
      </Link>
      <PatientVitals />
    </DashboardLayout>
  )
}

export default PatientVitalsPage

const useStyles = makeStyles(() => ({
  Backbtn: {
    marginRight: '20px',
    background: 'none',
    border: '0px',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    color: '#333',
    cursor: 'pointer',
    marginBottom: '15px',
    '@media (max-width:550px)': {
      marginBottom: '0px'
    }
  },
  Backicon: {
    marginRight: '5px'
  }
}))
